import React from "react";

export default function About() {
  return (
    <>
      <div className="div">
        <div className="builder-columns div-2">
          <div className="builder-column column">
            <div className="div-3">
              <div className="div-4">
                <div className="istockphoto-1159741374-612-x-612" />
                <div className="div-5">
                  <div className="builder-columns div-6">
                    <div className="builder-column column-2">
                      <div className="div-7">Who are we?</div>
                    </div>
                  </div>
                </div>
                <div className="div-8">
                  <div className="builder-columns div-9">
                    <div className="builder-column column-3">
                      <div className="div-10">Hi we are EnablePulse.</div>
                    </div>
                  </div>
                </div>
                <div className="div-11">
                  <div className="builder-columns div-12">
                    <div className="builder-column column-4">
                      <div className="div-13">
                        <div className="builder-columns div-14">
                          <div className="builder-column column-5">
                            <div className="we-are-into-connecting-creator">
                              We are into connecting creators to drive projects
                              to address the challenges faced by people of
                              disabilities and create a more inclusive society.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="builder-column column-6">
            <div className="div-15">
              <div className="builder-columns div-16">
                <div className="builder-column column-7">
                  <div className="div-17">
                    <div className="builder-columns div-18">
                      <div className="builder-column column-8">
                        <div className="div-19">
                          <div className="div-20" />
                          <div className="code-for-good-072719-ms-reactor-0">
                            <picture>
                              <source
                                srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?format=webp&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19"
                                type="image/webp"
                              />
                              <img
                                loading="lazy"
                                alt="image1"
                                src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19"
                                srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fa5f133c1074e464dac0b48bac7762a19"
                                className="image"
                              />
                            </picture>
                            <div className="builder-image-sizer image-sizer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .div {
          display: flex;
          flex-direction: column;
          max-width: 1393px;
        }
        .div-2 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-2 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(46.84% - 10px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column {
            width: 100%;
          }
        }
        .div-3 {
          display: flex;
          flex-direction: column;
          max-width: 653px;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 10px;
          padding-right: 10px;
          padding-bottom: 10px;
          padding-left: 10px;
        }
        .div-4 {
          display: flex;
          flex-direction: column;
          max-width: 701px;
          justify-content: flex-start;
          align-items: flex-start;
          padding-right: 88px;
          padding-bottom: 62px;
          padding-left: 20px;
          background-color: rgba(255, 255, 255, 1);
        }
        .istockphoto-1159741374-612-x-612 {
          display: flex;
          max-width: 154px;
          height: 158px;
          width: 154px;
        }
        .div-5 {
          display: flex;
          flex-direction: column;
          max-width: 384px;
          margin-top: 42px;
          padding-top: 10px;
          padding-right: 10px;
          padding-bottom: 10px;
          padding-left: 10px;
        }
        .div-6 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-6 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-2 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(102.54% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-2 {
            width: 100%;
          }
        }
        .div-7 {
          max-width: 100%;
          align-self: stretch;
          width: 364px;
          color: rgba(0, 0, 0, 1);
          font-size: 60px;
          letter-spacing: -3%;
          text-align: left;
          font-family: "Open Sans", sans-serif;
        }
        .div-8 {
          display: flex;
          flex-direction: column;
          max-width: 633px;
          margin-top: 42px;
          padding-right: 10px;
          padding-bottom: 10px;
          padding-left: 10px;
        }
        .div-9 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-9 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-3 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(101.49% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-3 {
            width: 100%;
          }
        }
        .div-10 {
          max-width: 613px;
          color: rgba(0, 0, 0, 1);
          font-size: 32px;
          letter-spacing: -3%;
          text-align: left;
        }
        .div-11 {
          display: flex;
          flex-direction: column;
          max-width: 643px;
          margin-top: 42px;
          padding-right: 10px;
          padding-bottom: 10px;
        }
        .div-12 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-12 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-4 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(101.44% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-4 {
            width: 100%;
          }
        }
        .div-13 {
          display: flex;
          flex-direction: column;
          max-width: 633px;
          padding-right: 10px;
          padding-bottom: 10px;
          padding-left: 10px;
        }
        .div-14 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-14 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-5 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(101.49% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-5 {
            width: 100%;
          }
        }
        .we-are-into-connecting-creator {
          max-width: 613px;
          color: rgba(0, 0, 0, 1);
          font-size: 32px;
          letter-spacing: -3%;
          text-align: left;
          font-family: "Open Sans", sans-serif;
        }
        .column-6 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(53.08% - 10px);
          margin-left: 20px;
        }
        @media (max-width: 999px) {
          .column-6 {
            width: 100%;
          }
        }
        .div-15 {
          display: flex;
          flex-direction: column;
          max-width: 740px;
          padding-top: 10px;
          padding-right: 10px;
          padding-bottom: 10px;
          padding-left: 10px;
        }
        .div-16 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-16 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-7 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(101.27% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-7 {
            width: 100%;
          }
        }
        .div-17 {
          display: flex;
          flex-direction: column;
          max-width: 720px;
        }
        .div-18 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-18 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column-8 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(99.86% - 0px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column-8 {
            width: 100%;
          }
        }
        .div-19 {
          display: flex;
          flex-direction: column;
          max-width: 720px;
          justify-content: flex-start;
          align-items: flex-end;
          padding-top: 31px;
          padding-right: 82px;
          padding-bottom: 31px;
          background-color: rgba(255, 255, 255, 1);
        }
        .div-20 {
          display: flex;
          max-width: 371px;
          height: 70px;
          width: 371px;
        }
        .code-for-good-072719-ms-reactor-0 {
          display: flex;
          align-self: stretch;
          position: relative;
          min-width: 20px;
          min-height: 20px;
          max-width: 534px;
          margin-top: 169px;
        }
        .image {
          object-fit: cover;
          object-position: center;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
        }
        .image-sizer {
          width: 100%;
          padding-top: 80.71161048689139%;
          pointer-events: none;
          font-size: 0;
        }
      `}</style>
    </>
  );
}
